import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';
import DeleteButton from '../components/DeleteButton';
import EntityDetailLayout from '../components/EntityDetailLayout';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'raw', label: 'Raw' },
];

function OrganizationDetail() {
  const { organizationId } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/hdp/organizations/${organizationId}`);
        setOrg(res.data);
      } catch (err) {
        console.error(err);
        setOrg(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [organizationId]);

  return (
    <EntityDetailLayout
      entityType="organization"
      title={org?.name || 'Organization'}
      subtitle={org?.org_type}
      breadcrumbs={[
        { label: 'Dashboard', to: '/' },
        { label: 'Organizations', to: '/organizations' },
        { label: org?.name || organizationId },
      ]}
      tabs={TABS}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      loading={loading}
      notFound={!loading && !org ? 'Organization not found.' : null}
      notFoundAction={<Link to="/organizations" className="btn btn-secondary btn-sm">Back to organizations</Link>}
      headerActions={org && (
        <DeleteButton
          confirmMessage={`Delete organization "${org.name}"?`}
          onDelete={async () => {
            await api.delete(`/hdp/organizations/${organizationId}`);
            navigate('/organizations');
          }}
        />
      )}
      sidebar={org && (
        <>
          <div className="entity-sidebar-section">
            <div className="entity-sidebar-title">Country</div>
            <strong>{org.country || '—'}</strong>
          </div>
          <div className="entity-sidebar-section">
            <div className="entity-sidebar-title">Sector</div>
            <strong>{org.sector || '—'}</strong>
          </div>
          {org.website && (
            <div className="entity-sidebar-section">
              <div className="entity-sidebar-title">Website</div>
              <a href={org.website} target="_blank" rel="noreferrer">{org.website}</a>
            </div>
          )}
        </>
      )}
    >
      {activeTab === 'overview' && org && (
        <div className="entity-kv-grid">
          <div><span>Type</span><strong>{org.org_type}</strong></div>
          <div><span>Country</span><strong>{org.country || '—'}</strong></div>
          <div><span>Sector</span><strong>{org.sector || '—'}</strong></div>
          <div className="entity-kv-wide">
            <span>Description</span>
            <p>{org.description || '—'}</p>
          </div>
          <div className="entity-kv-wide">
            <span>Labels</span>
            <div className="entity-tag-list">
              {(org.labels || []).map((tag) => (
                <span key={tag} className="entity-tag">{tag}</span>
              ))}
            </div>
          </div>
        </div>
      )}
      {activeTab === 'raw' && org && (
        <pre className="entity-raw-json">{JSON.stringify(org, null, 2)}</pre>
      )}
    </EntityDetailLayout>
  );
}

export default OrganizationDetail;
